// src/amplifyConfig.js
import { Amplify, Hub } from 'aws-amplify';

// Configure Auth
Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: 'us-east-2',

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: 'us-east-2_xzDnCbCEO',

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: '6b90agk2p4g04g5m2tpc27rejv',

    // OPTIONAL - Amazon Cognito Identity Pool ID
    identityPoolId: 'us-east-2:ef1d578a-8f02-4984-b15f-c5ade001a098'
  }
});

// Listen for auth events
Hub.listen('auth', ({ payload: { event, data } }) => {
  if (event === 'signIn') {
            console.debug('User signed in, refreshing credentials');
    // Force reload of app after sign-in to refresh credentials
    window.location.reload();
  }
});
